"use client";

import { useEffect, useState } from "react";

interface DeviceDetection {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

export const useDeviceDetection = (): DeviceDetection => {
  const [device, setDevice] = useState<DeviceDetection>({
    isMobile: false,
    isTablet: false,
    isDesktop: true,
  });

  useEffect(() => {
    const checkDevice = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const width = window.innerWidth;

      // Check for mobile devices based on user agent and screen width
      const isMobile =
        /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
          userAgent,
        ) || width < 768;

      // Check for tablet (iPad or Android tablet with larger screen)
      const isTablet =
        (/ipad|android/i.test(userAgent) && width >= 768 && width < 1024) ||
        (width >= 768 && width < 1024);

      const isDesktop = width >= 1024;

      setDevice({
        isMobile: isMobile && !isTablet,
        isTablet,
        isDesktop,
      });
    };

    // Initial check
    checkDevice();

    // Listen for resize events
    window.addEventListener("resize", checkDevice);

    return () => {
      window.removeEventListener("resize", checkDevice);
    };
  }, []);

  return device;
};
